import styled from "styled-components";

// The overview shows the content laid out like the "Koç Gönüllüleri Nedir?" section of the site (text on the left, a
// 320 × 320 image on the right), in the colours of the admin panel. Narrow screens move the image under the text.
export const LanguageSwitchContainer = styled.label`
	display: flex;
	align-items: center;
	gap: 12px;
	color: #2e333e;
	font-size: 15px;
	cursor: pointer;
`;

export const AboutPreview = styled.section`
	display: flex;
	flex-wrap: wrap;
	align-items: flex-start;
	gap: 24px;
	padding: 32px 20px 12px;
`;

export const AboutPreviewText = styled.div`
	flex: 1 1 320px;
	min-width: 0;
`;

export const AboutPreviewTitle = styled.h2`
	margin: 0 0 16px;
	color: #1a202c;
	font-size: clamp(22px, 2vw, 32px);
	font-weight: 600;
	line-height: 1.25;
	overflow-wrap: anywhere;
`;

export const AboutPreviewDescription = styled.p`
	margin: 0;
	color: #2e333e;
	font-size: 16px;
	line-height: 24px;
	white-space: pre-line;
	overflow-wrap: anywhere;
`;

export const AboutPreviewImage = styled.div`
	display: flex;
	flex: 0 0 320px;
	align-items: center;
	justify-content: center;
	width: 320px;
	height: 320px;
	overflow: hidden;
	color: #8b8b8b;
	font-size: 56px;
	background-color: #f2f6fa;
	/* An outline keeps the image at its full 320 × 320 size. */
	outline: 1px solid #e4e7ed;

	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
`;

// Empty, error and loading states: a grey icon, the message and the action under it, centred in the card.
export const AboutStateContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 16px;
	min-height: 360px;
	padding: 24px;
	text-align: center;

	> .anticon {
		color: #8b8b8b;
		font-size: 48px;
	}
`;

export const AboutStateMessage = styled.p`
	max-width: 520px;
	margin: 0;
	color: #2e333e;
	font-size: 16px;
	line-height: 24px;
`;
